var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectionSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.3435V16.2935C12.5 15.8602 13.7083 15.0268 14.625 13.7935C15.5417 12.5602 16 11.1602 16 9.59351C16 8.02684 15.5417 6.62684 14.625 5.39351C13.7083 4.16017 12.5 3.32684 11 2.89351V0.843506C13.0667 1.31017 14.75 2.35601 16.05 3.98101C17.35 5.60601 18 7.47684 18 9.59351C18 11.7102 17.35 13.581 16.05 15.206C14.75 16.831 13.0667 17.8768 11 18.3435ZM0 12.6185V6.61851H4L9 1.61851V17.6185L4 12.6185H0ZM11 13.6185V5.56851C11.7833 5.93517 12.3958 6.48517 12.8375 7.21851C13.2792 7.95184 13.5 8.75184 13.5 9.61851C13.5 10.4685 13.2792 11.256 12.8375 11.981C12.3958 12.706 11.7833 13.2518 11 13.6185ZM7 6.46851L4.85 8.61851H2V10.6185H4.85L7 12.7685V6.46851Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionSpeaker);
export default __webpack_public_path__ + "static/media/protection_speaker.1797f3aaa413d6ae306e2c2e65e70bff.svg";
export { ForwardRef as ReactComponent };